<template>
  <div class="facility-control">
    <!-- 下拉选择器 -->
    <el-select
        v-model="selectedLocation"
        placeholder="选择水库"
        clearable
        filterable
        @change="handleLocationChange"
        class="location-select"
    >
      <el-option-group
          v-for="group in locationGroups"
          :key="group.label"
          :label="group.label"
      >
        <el-option
            v-for="item in group.options"
            :key="item.id"
            :label="item.name"
            :value="item.id"
        >
          <span style="float: left">{{ item.name }}</span>
          <span style="float: right; color: #8492a6; font-size: 13px">
            {{ item.type || '地点' }}
          </span>
        </el-option>
      </el-option-group>
    </el-select>
  </div>
</template>

<script>
import * as Cesium from 'cesium'
import {hyStations} from '@/common/js/position'

export default {
  name: 'ReservoirControl',
  data() {
    return {
      selectedLocation: null,
      locationGroups: []
    }
  },
  mounted() {
    this.initLocationData()
  },
  methods: {
    initLocationData() {
      // 组织地点数据
      this.locationGroups = [
        {
          label: '水库',
          options: hyStations.map(item => ({
            ...item,
            type: '水库'
          }))
        }
      ]
    },

    handleLocationChange(locationId) {

      if (locationId=='h1'){
        if (window.viewer){
          window.viewer.camera.flyTo({
            destination: Cesium.Cartesian3.fromDegrees(110.4518, 36.0662, 2200),
            orientation: {
              heading: 6.1954683771508625,
              pitch: -0.26627765921030777,
              roll: 0.0000028015751460941374
            }
          })
        }

      }else if (locationId=='h8'){
        if (window.viewer){
          window.viewer.camera.flyTo({
            destination: Cesium.Cartesian3.fromDegrees(110.309280, 35.526455, 2200),
            orientation: {
              heading: 4.073307009772927,
              pitch: -0.3676531544625212,
              roll: 6.280457769978864
            }
          })
        }
      } else {
        if (!locationId) {
          this.selectedLocation = null
          return
        }

        // 根据ID查找对应的位置信息
        const location = this.findLocationById(locationId)
        if (location) {
          this.flyToLocation(location)
        }
      }
    },

    findLocationById(id) {
      for (const group of this.locationGroups) {
        const location = group.options.find(item => item.id === id)
        if (location) {
          return location
        }
      }
      return null
    },

    findLocationByName(name) {
      for (const group of this.locationGroups) {
        const location = group.options.find(item => item.name === name)
        if (location) {
          return location
        }
      }
      return null
    },

    flyToLocation(location) {
      if (!window.viewer) {
        console.error('Cesium viewer 未初始化')
        return
      }

      const [longitude, latitude, height] = location.location

      // 飞行到指定位置
      window.viewer.camera.flyTo({
        destination: Cesium.Cartesian3.fromDegrees(
            longitude,
            latitude,
            1500
        ),
        orientation: {
          heading: 0.0,
          pitch: -Math.PI / 4,
          roll: 0.0
        },
        duration: 2.0, // 飞行时间2秒
        complete: () => {
          console.log(`已定位到: ${location.name}`)
        }
      })

      // 添加定位成功提示
      this.$message.success(`已定位到: ${location.name}`)
    },

    // 外部调用的方法：通过名称定位
    flyToByName(name) {
      const location = this.findLocationByName(name)
      if (location) {
        this.selectedLocation = location.id
        this.flyToLocation(location)
        return true
      }
      this.$message.error(`未找到地点: ${name}`)
      return false
    },

    // 外部调用的方法：通过ID定位
    flyToById(id) {
      const location = this.findLocationById(id)
      if (location) {
        this.selectedLocation = id
        this.flyToLocation(location)
        return true
      }
      this.$message.error(`未找到ID为 ${id} 的地点`)
      return false
    }
  }
}
</script>

<style scoped>
.facility-control {
  position: absolute;
  top: 144px;
  left: 22px;
  z-index: 9999;
  padding: 8px;
  border: 1px solid rgba(56, 189, 248, 0.18);
  border-radius: 8px;
  background: rgba(2, 23, 30, 0.72);
  box-shadow: 0 12px 34px rgba(0, 0, 0, 0.28);
  backdrop-filter: blur(10px);
}

.location-select {
  width: 220px;
}

.location-select ::v-deep(.el-input__inner) {
  background: rgba(255, 255, 255, 0.055);
  border: 1px solid rgba(56, 189, 248, 0.28);
  color: #e6fbff;
  font-weight: 500;
  border-radius: 6px;
  height: 34px;
  line-height: 34px;
  box-shadow: none;
  transition: all 0.2s ease;
}

.location-select ::v-deep(.el-input__inner:hover) {
  background: rgba(56, 189, 248, 0.08);
  border-color: rgba(56, 189, 248, 0.5);
}

.location-select ::v-deep(.el-input__inner:focus) {
  background: rgba(56, 189, 248, 0.08);
  border-color: rgba(56, 189, 248, 0.62);
  box-shadow: 0 0 16px rgba(56, 189, 248, 0.14);
  outline: none;
}

/* 下拉框样式 */
.location-select ::v-deep(.el-select-dropdown) {
  background-color: #fff;
  border: 1px solid #409eff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.location-select ::v-deep(.el-select-dropdown__item) {
  color: #333;
}

.location-select ::v-deep(.el-select-dropdown__item:hover) {
  background-color: rgba(64, 158, 255, 0.1);
}

/* 分组选项标题 */
.location-select ::v-deep(.el-select-group__title) {
  color: #409eff;
  font-weight: bold;
  background-color: rgba(64, 158, 255, 0.1);
}

</style>
